import "./Projects.css";
import config from "../Config/Config.json";

function Projects() {


    // const mProjectData = [
    //     {
    //         project_name: "Project Name 01",
    //         project_desc: "I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font. I’m a great place for you to tell a story and let your users know a little more about you.",
    //         project_img: "https://picsum.photos/800/500",            
    //     },
    // ];
    
  return (
  <div className="projects-div">
    <hr className="divider"/>
    <h1>Projects</h1>
    <br/>
    {config.project_section.map((item, index) => (
        <div className="projects-section">
            <div className="projects-info">
                <div className="projects-role">{item.project_name}</div>
                <div className="projects-role-desc">{item.project_desc}</div>
                <a className="projects-role-desc" href={item.project_link}>{item.project_name.split("- ")[1]}</a>
            </div>
            {/* <img className="project-photo" alt="Project" src={item.project_img} /> */}
            <div className="project-photo">
              <div className="phone-frame">
                <a className="projects-role-desc" href={item.project_link}>
                  <img
                  src={item.project_img}
                  title="Mobile View"
                  className="phone-screen" />
                </a>
              </div>
            </div>
      </div>
    ))}
    <hr className="divider"/>
  </div>
);

}
export default Projects;